import React, { PureComponent } from "react";
import { reduxForm } from "redux-form";
import EyeIcon from "mdi-react/EyeIcon";
import KeyVariantIcon from "mdi-react/KeyVariantIcon";
import AccountOutlineIcon from "mdi-react/AccountOutlineIcon";
import MailRuIcon from "mdi-react/MailRuIcon";
import { Alert } from "reactstrap";

class RegisterForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      username: "",
      email: "",
      password: ""
    };

    this.showPassword = this.showPassword.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmitRegister = this.handleSubmitRegister.bind(this);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmitRegister(event) {
    event.preventDefault();
    // if (this.state.username.includes(" ")) {
    //   alert("Username cannot contain whitespaces");
    //   return false;
    // }
    this.props.onSubmit(this.state);
  }

  render() {
    return (
      <div>
        {this.props.isLoginError ? (
          <Alert color="danger">
            <div className="alert__content">
              <p>
                <span className="bold-text">Error!</span>{" "}
                {this.props.loginErrorMsg}
              </p>
            </div>
          </Alert>
        ) : (
          <div />
        )}
        <form className="form" onSubmit={this.handleSubmitRegister}>
          <div className="form__form-group">
            <label className="form__form-group-label">Username</label>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <AccountOutlineIcon />
              </div>
              <input
                type="text"
                name="username"
                placeholder="Username"
                onChange={this.handleInputChange}
                required
              />
            </div>
          </div>
          <div className="form__form-group">
            <label className="form__form-group-label">E-mail</label>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <MailRuIcon />
              </div>
              <input
                type="email"
                name="email"
                placeholder="example@mail.com"
                onChange={this.handleInputChange}
                required
              />
            </div>
          </div>
          <div className="form__form-group form__form-group--forgot">
            <label className="form__form-group-label">Password</label>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <KeyVariantIcon />
              </div>
              <input
                type={this.state.showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                onChange={this.handleInputChange}
                required
              />
              <button
                className={`form__form-group-button${
                  this.state.showPassword ? " active" : ""
                }`}
                onClick={e => this.showPassword(e)}
              >
                <EyeIcon />
              </button>
            </div>
          </div>
          <input
            type="submit"
            className="btn btn-primary account__btn"
            value="Sign Up"
            disabled={this.props.isLoading}
          />
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: "register_form" // a unique identifier for this form
})(RegisterForm);



// WEBPACK FOOTER //
// ./src/pages/account/register/components/RegisterForm.js